.modal-description {
  margin: var(--space-24) var(--space-0);
}

.modal-body {
  height: auto;
  padding: var(--space-0) var(--space-16) var(--space-16);
}

.validation-options {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--space-8);
}

.address {
  font-size: 14px;
}

.checklist {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 95%;
  gap: var(--space-8);
}

.radio-address {
  display: flex;
}

.label-and-radio {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.address-radio-button {
  display: flex;
  align-items: center;
  padding: var(--space-0);
  height: 24px;
}

.address-edit-button {
  font-weight: 500;
  margin: var(--space-0);
}

.original-address {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-8);
}

.validation-error {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: auto;
  height: 100%;
  gap: var(--space-8);
  margin-top: var(--space-8);
}

.address-error-label {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
}
